import axios from 'axios';
import { Env } from '@/configuration';
import { Event, UpdatePresence } from './models';

import { getTokenSilently } from '@/auth/auth';
import { EventForWidget } from '../components/EventsWidget/models';
import { getAuthService } from '@/auth';

// const authService = getAuthService();

const fetchEvents = async () => {
  const eventsUrl = Env.AdminApiOptions.endpointUrl('events');
  const accessTokenValue: string = await getTokenSilently();
  const response = await axios.get(eventsUrl, { headers: { Authorization: `Bearer ${accessTokenValue}` }});
  // const response = await axios.get(eventsUrl);
  const result: Event[] = response && response.data;
  return result;
};

const fetchEvent = async (eventId: string) => {
  const eventItemUrl = Env.AdminApiOptions.endpointUrl(`events/${eventId}`);
  const accessTokenValue: string = await getTokenSilently();
  const response = await axios.get(eventItemUrl, { headers: { Authorization: `Bearer ${accessTokenValue}` }});
  const result: Event = response && response.data;
  return result;
};

const saveEvent = async (event: Event) => {
  const endpointUrl = Env.AdminApiOptions.endpointUrl(`events`);
  const accessTokenValue: string = await getTokenSilently();
  const saveAction = event.id == null
    ? () => axios.post(endpointUrl, event, { headers: { Authorization: `Bearer ${accessTokenValue}` }})
    : () => axios.put(endpointUrl, event, { headers: { Authorization: `Bearer ${accessTokenValue}` }});

  const response = await saveAction();
  const result: any = response && response.data;

  return result;
};

const deleteEvent = async (eventId: number) => {
  const deleteEventUrl = Env.AdminApiOptions.endpointUrl(`events/${eventId}`);
  const accessTokenValue: string = await getTokenSilently();
  const response = await axios.delete(deleteEventUrl, { headers: { Authorization: `Bearer ${accessTokenValue}` }});
  const result: any = response && response.data;

  return result;
};

const fetchEventsForWidget = async () => {
  const url = Env.CoreApiOptions.endpointUrl('events/forWidget');
  let response;
  if (getAuthService().isAuthenticated) {
    // console.log('get events for widget as authenticated user');
    response = await axios.get(url, { headers: { Authorization: `Bearer ${await getTokenSilently()}` }});
  } else {
    // console.log('get events for widget as anonymous user');
    response = await axios.get(url);
  }
  const result: EventForWidget[] = response && response.data;
  return result;
};

const updatePresence = async (updatePresenceModel: UpdatePresence) => {
  const endpointUrl = Env.CoreApiOptions.endpointUrl(`events/updatePresence`);
  const response = await axios.put(endpointUrl, updatePresenceModel, { headers: { Authorization: `Bearer ${await getTokenSilently()}` }});
  const result: any = response && response.data;

  return result;
};

export default {
  fetchEvents,
  fetchEventsForWidget,
  fetchEvent,
  saveEvent,
  deleteEvent,
  updatePresence,
};
